var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("RenderMoneyColumnValue", {
        attrs: { value: _vm.invoiceValue || 0, "max-fraction-digits": 0 }
      }),
      _vm._v("\n  |\n  "),
      _c("RenderPercentageColumnValue", {
        style: _vm.setInvoiceSummaryStatusColor(),
        attrs: { value: _vm.percentageInvoiceValue }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }